import * as React from 'react'
import Icon, { IconKey } from 'components/ui/icon'
import styles from './index.module.css'

type Props = {
  children: React.ReactNode
  title: string
  icon?: IconKey
  footer?: React.ReactNode
}

/**
 * Dashboard card component with header, content area, and optional footer
 * Provides a consistent card layout for dashboard widgets with icon and title
 * @param children - Content to display in the card body
 * @param title - Title text to display in the card header
 * @param icon - Optional icon to display in the card header
 * @param footer - Optional footer content to display at the bottom
 */
const DashboardCard = (props: Props): React.ReactElement<'div'> => {
  const { children, title, icon, footer } = props
  return (
    <div className={styles.dashboardDashboardCard}>
      <div className={styles.dashboardDashboardCardHeader}>
        <div className={styles.dashboardDashboardCardTitle}>{title}</div>
        {icon && (
          <div className={styles.dashboardDashboardCardIcon}>
            <Icon type={icon} width="24" height="24" />
          </div>
        )}
      </div>
      <div className={styles.dashboardDashboardCardContent}>{children}</div>
      {footer && (
        <div className={styles.dashboardDashboardCardFooter}>{footer}</div>
      )}
    </div>
  )
}

export default DashboardCard
